<template>
  <v-container fluid>
    <dashboard-statistika v-if="roleRGV" />

    <dashboard-paslaugos v-if="roleDT" class="mb-5" />

    <dashboard-pranesimai v-if="roleDT || roleSkaito" />
  </v-container>
</template>

<script>
import userRole from '../../../mixins/userRole'
import DashboardPaslaugos from './DashboardPaslaugos'
import DashboardPranesimai from './DashboardPranesimai'
import DashboardStatistika from './DashboardStatistika'

export default {
  name: 'HipotekaDashboard',
  components: {
    DashboardPaslaugos,
    DashboardPranesimai,
    DashboardStatistika,
  },
  mixins: [userRole],
  data() {
    return {
      //
    }
  },
  computed: {
    roleSkaito() {
      return this.role('DT_JA_Skaito')
    },
  },
  created() {
    //
  },
  methods: {
    //
  },
}
</script>
